/**
 * This file contains SQL command for setting up security roles and users in Snowflake.
 * The `sqlCommandCreateUserAndRole`, establishes a read-only role named BreezeSecurityReadOnly,
 * grants it necessary privileges, and creates a user and password for authentication and integration with specific configurations.
 */

export const sqlCommandCreateUserAndRoleTemplate = `
      -- Declare variables
      DECLARE
          current_warehouse STRING; -- To store the name of the current warehouse
          result RESULTSET; -- To store the result of the DESCRIBE USER command
      BEGIN
          -- Fetch the name of the current warehouse and store it in the variable
          SELECT CURRENT_WAREHOUSE() INTO :current_warehouse;

          -- Create a new role named 'BreezeSecurityReadOnly'
          CREATE OR REPLACE ROLE BreezeSecurityReadOnly;

          -- Create a new user 'BreezeUser' with specified login name and password
          CREATE OR REPLACE USER BreezeUser
            LOGIN_NAME=BREEZEUSER -- Set login name for the user
            RSA_PUBLIC_KEY="{{RSA_PUBLIC_KEY}}" -- Set the RSA public key for the user
            DEFAULT_ROLE=BreezeSecurityReadOnly -- Assign the default role to the user
            DEFAULT_WAREHOUSE=:current_warehouse -- Assign the current warehouse as the default warehouse
            TYPE=SERVICE; -- Set the user type as SERVICE

          -- Grant the 'BreezeSecurityReadOnly' role to the newly created user
          GRANT ROLE BreezeSecurityReadOnly TO USER BreezeUser;
    
          -- Grant imported privileges on the 'snowflake' database to the role
          GRANT IMPORTED PRIVILEGES on database snowflake to role BreezeSecurityReadOnly;
          
          -- Dynamically grant the 'USAGE' privilege on the current warehouse to the role
          EXECUTE IMMEDIATE
              'GRANT USAGE ON WAREHOUSE ' || current_warehouse || ' TO ROLE BreezeSecurityReadOnly';

          -- Execute a command to show the user 'BreezeUser' and store the result
          result := (SHOW TERSE USERS LIKE 'BreezeUser');

          -- Return the result of the SHOW USERS command
          RETURN TABLE(result);
      END;`;

const getSnowflakeCreateUserAndRoleSqlCommand = (public_key) => {
  return sqlCommandCreateUserAndRoleTemplate.replace(
    "{{RSA_PUBLIC_KEY}}",
    public_key
  );
};

export default getSnowflakeCreateUserAndRoleSqlCommand;
